<template>
<div>
  <div class="container">
    <div class="row">
      <div class="d-flex mb-5 w-100">
        <div class="col-lg-6 pl-5 font-leadin">
          <h2>WORK</h2>
          <p>We create compelling solutions to exceed your brand and business goals.</p>
        </div>
        <div class="col-lg-6 d-flex w-100 h-100 justify-content-center align-items-center">
          <a class="btn btn-almost-black-outline btn-lg" href="#filter" data-toggle="collapse" data-target="#filter" aria-expanded="false" aria-controls="filter" @click="togglefiltersOpen">Search<i class="ml-3 fal fa-chevron-down" v-if="!filtersOpen"></i><i class="ml-3 fal fa-chevron-up" v-if="filtersOpen"></i></a>
        </div>
      </div>
    </div>
  </div>
  <div class="collapse w-100" id="filter" app-call="app.projects.navigation">
    <div class="section align-items-center d-flex bg-dark-gray">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="row mb-36">
              <!-- <div class="align-items-center d-flex">
                            <button class="btn" @click="toggleShowSearchText()"><i class="fal fa-search fz-24"></i></button>
              </div>-->
              <div class="align-items-center d-flex col-xl-7 mx-auto">
                <div class="input-group color-dark-gray px-2 animated fadeIn display-inline-block">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search Projects"
                    aria-label="Search Projects"
                    v-model="searchString"
                  />
                  <div class="input-group-append">
                    <button class="btn btn-windward-blue" type="button" @click="searchPosts">
                      <i class="fal fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-24">
              <button
                class="btn btn-windward-blue btn-sm mx-auto"
                @click.stop.prevent="setTerm('all', 'All')"
              >Show All</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="container"></div>
  </div>
  <div class="sr-alert sr-only" role="alert" v-html="srAlert"></div>
</div>
</template>
<script>
export default {
  created() {
    // console.info("projects1 created");
  },
  mounted() {
    // console.log('projects mounted');
  },
  methods: {
    setTerm: function(slug, heading) {
      app.projects.projectsApp.setTerm(slug, heading);
      let $this = this;
      this.srAlert = "";
      setTimeout(function(){
        $this.srAlert = "Projects have been updated";
        let $target = document.querySelectorAll(".section-projects .project-item:first-child a:first-child");
        $target[0].focus();
      },500);
    },
    searchPosts: function() {
      app.projects.projectsApp.searchPosts(this.searchString);
      let $this = this;
      this.srAlert = "";
      setTimeout(function(){
        $this.srAlert = "Projects have been updated";
        let $target = document.querySelectorAll(".section-projects .project-item:first-child a:first-child");
        $target[0].focus();
      },500);
    },
    toggleShowSearchText: function() {
      this.showSearchText = !this.showSearchText;
    },
    togglefiltersOpen: function() {
        this.filtersOpen = !this.filtersOpen;
    }
  },
  data: {
    showSearchText: false,
    searchString: "",
    filtersOpen: false,
    srAlert: ""
  }
};
</script>
